import { lazy, Suspense } from 'react';
import { useBrand } from '../../context/BrandContext';
import { Spinner } from '../ui/spinner';
import VipDashboardSection from '../VipDashboardSection';

const brandViews = {
  cashy: lazy(() => import('./brands/cashy/VipDashboard')),
};

export function VipDashboardModule() {
  const { activeBrand } = useBrand();
  const BrandView = brandViews[activeBrand];
  if (BrandView) {
    return (
      <Suspense fallback={<div className="flex justify-center py-12"><Spinner /></div>}>
        <BrandView />
      </Suspense>
    );
  }
  return <VipDashboardSection />;
}
